import { AxiosResponse } from "axios";
import { taxGuruAxios } from "../axios";
import { TaxChangelogDto } from "../static/TaxChangelogDto";

export type ActuatorInfoType = {
    app: {
        profile: "local" | "dev" | "test" | "prod" | "learning";
        /**
         * Zapnutí chatbota Maica, property `info.app.chatbot` na backendu.
         *
         * Je to **řetězec**, ne boolean – actuator vrací hodnoty z `info.*` tak, jak stojí
         * v properties (ověřeno na `/actuator/info`: `"chatbot":"true"`). Pozor na to při
         * testování hodnoty: `"false"` je v JavaScriptu pravdivý řetězec. Vyhodnocuje ho
         * `MaicaChatbot`.
         */
        chatbot?: string;
    };
    build: {
        artifact: "string";
        name: "string";
        time: "string";
        version: "string";
        group: "string";
    };
};

export const getActuatorInfo = (): Promise<AxiosResponse<ActuatorInfoType>> => {
    return taxGuruAxios.get("/actuator/info", { withCredentials: false });
};

export const getChangelog = (): Promise<TaxChangelogDto> => {
    return taxGuruAxios.get("/actuator/changelog", { withCredentials: false }).then(({ data }) => data);
};
